import { useEffect, useState } from "react";

// Component and CSS map
const componentMap = {
    "Slider_Temp": {
        component: () => import("./SliderWidget"),
        cssFile: `${process.env.PUBLIC_URL}/testimonials/temp-css/testimonials-temp.css`, 
    },
    "Rotator_Temp": {
        component: () => import("./RotatorWidget"),
        cssFile: `${process.env.PUBLIC_URL}/testimonials/temp-css/testimonials-temp.css`, 
    },
    "Carousel_Temp": {
        component: () => import("./CarouselWidget"),
        cssFile: `${process.env.PUBLIC_URL}/testimonials/temp-css/testimonials-temp.css`, 
    },
    "Cards_Temp": {
        component: () => import("./CardsWidget"),
        cssFile: `${process.env.PUBLIC_URL}/testimonials/temp-css/testimonials-temp.css`, 
    },
    "Dark_Carousel_Temp": {
        component: () => import("./DarkCarouselWidget"),
        cssFile: `${process.env.PUBLIC_URL}/testimonials/temp-css/testimonials-temp.css`, 
    },
    "Customer_Story_Temp": {
        component: () => import("./CustomerStoryWidget"),
        cssFile: `${process.env.PUBLIC_URL}/testimonials/temp-css/testimonials-temp.css`, 
    },
}; 

const DynamicTemplate = ({ selectedTemplate, isTemplateId, widgetId, selectedLayout, testimonialTabData }) => {
    const [TemplateComponent, setTemplateComponent] = useState(null);

    useEffect(() => {
        const loadTemplate = async () => {
            const template = componentMap[selectedTemplate];
            if (!template) {
                setTemplateComponent(null);
                return;
            }

            // Remove all previously injected dynamic CSS
            const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
            oldLinks.forEach(link => link.remove());

            // Inject new CSS
            if (template.cssFile) {
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = template.cssFile;
                if (widgetId) {
                    link.setAttribute("testimonials-data-dynamic-css", selectedTemplate);
                } else {
                    link.setAttribute("data-dynamic-css", selectedTemplate);
                }
                document.head.appendChild(link);
            }

            // Load component
            const componentModule = await template.component();
            setTemplateComponent(() => componentModule.default);
        };

        loadTemplate();
    }, [selectedTemplate,widgetId]);

    if (!TemplateComponent)
        return (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading please wait...</p>
            </div>
        );

    return (
        <TemplateComponent selectedTemplate={selectedTemplate} selectedLayout={selectedLayout} isTemplateId={isTemplateId} widgetId={widgetId} testimonialTabData={testimonialTabData}
        /> 
    );
};

export default DynamicTemplate;
